import React, { useState, useEffect } from 'react';
import ggif from './Images/Rosa G New.gif';
import Delhi from './Images/Delhi.mp3';
import { useNavigate } from 'react-router-dom';

const Rosag_Sync = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    const userEmail = sessionStorage.getItem('userEmail');
    setEmail(userEmail);

    const video = document.getElementById('video');
    const canvas = document.getElementById('canvas');
    const context = canvas.getContext('2d');
    let stream;
    let interval;

    const startCamera = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: true });
        video.srcObject = stream;
        video.play();

        // Set canvas size to match the video size
        video.addEventListener('loadedmetadata', () => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
        });

        captureAndSendImage();
        interval = setInterval(captureAndSendImage, 5000);
      } catch (error) {
        console.error('Error accessing camera:', error);
      }
    };

    const stopCamera = () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      if (interval) {
        clearInterval(interval);
      }
    };

    const captureAndSendImage = async () => {
      try {
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL('image/jpeg');
        const blob = dataURLToBlob(dataURL);
        const formData = new FormData();
        formData.append('image', blob, 'image.jpg');
        formData.append('path', `/var/www/myflaskapp/flask_static/${email}/RosaG`);

        console.log('Sending image to IMGAPI');
        const picapiResponse = await fetch('https://www.hydaxdroid.com/IMGAPI', {
          method: 'POST',
          body: formData,
        });
        console.log('IMGAPI response:', await picapiResponse.json());

        console.log('Sending image to FACEAPI');
        const faceapiResponse = await fetch('https://www.hydaxdroid.com/FACEAPI', {
          method: 'POST',
          body: formData,
        });
        const faceapiResult = await faceapiResponse.json();
        console.log('FACEAPI response:', faceapiResult.message);
        setMessage(faceapiResult.message);

        if (faceapiResult.message === 'Face detected') {
          openRelayControl(); // Open relay control on face detection
          stopCamera(); // Stop the camera and clear interval
          navigate('/face_detectedg', { state: { imageUrl: faceapiResult.image_url } });
        }
      } catch (error) {
        console.error('Error capturing or sending image:', error);
      }
    };

    const dataURLToBlob = (dataURL) => {
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    };

    const openRelayControl = () => {
      const relayUrl = 'http://192.168.0.100/relay1/on';
      console.log('Face detected: Opening relay control URL:', relayUrl);

      // Open the relay control URL in a new window
      const relayWindow = window.open(relayUrl, '_blank', 'width=400,height=400');

      // Close the relay window after 1 second
      setTimeout(() => {
        if (relayWindow) {
          relayWindow.close();
        }
      }, 1000); // 1 second
    };

    startCamera();

    return () => {
      stopCamera(); // Cleanup on component unmount
    };
  }, [navigate, email]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '0 10px' }}>
      <img src={ggif} alt="Pink Eyes" style={{ width: '100%', maxWidth: '640px', height: 'auto', marginBottom: '20px' }} />
      <audio id="hiddenAudio" controls autoPlay loop style={{ display: 'none' }}>
        <source src={Delhi} />
      </audio>

      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <video
            id="video"
            autoPlay
            style={{
              width: '100%',
              maxWidth: '320px',
              borderRadius: '15px',
              border: '3px solid #ff69b4',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            }}
          ></video>
          <canvas
            id="canvas"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'none',
            }}
          ></canvas>
        </div>
      </div>

      <div id="message" style={{ textAlign: 'center', marginTop: '20px' }}>
        {message}
      </div>
      <footer className="footer-section">
        <div className="container-4">
          <div className="text-6">&copy; 2022 HYDAX Pvt. Ltd. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
};

export default Rosag_Sync;
